<template>
    <div id="connections-add-page">
        <div class="container-fluid">
            <sender-form ref="senderForm" 
                :place_sender="activePlaceSender" 
                :sender="activeSender" 
                :senders="senders" 
                @saved="savedSender" 
                @done="done"
                action="add"
                />
            <div class="box padding-large page-content">
                <div class="title-container">
                    <h1>{{ t('settings-connections-add_page_title') }}</h1>
                </div>
                <div class="picker">
                    <side-nav :items="navItems" :active="active" @pick="pick" />
                    <div class="cards-content">
                        <loader v-if="loading" :addBackground="true"></loader>

                        <category 
                        v-for="(category,idx) in categories"
                        v-show="(active == idx || active == 'all') && category.senders.length > 0 && (idx !== 'rcs' || $module('rcs'))"
                        :key="idx"
                        :title="category.title"
                        :description="category.description"
                        >
                            <card 
                                v-for="sender in category.senders"
                                :key="sender.id" 
                                :disabled="sender.accepting_registration === '0'"
                                :viaKevi="sender.by_kevi == '1'" 
                                :title="sender.title" 
                                :description="sender.description"
                                :monthly-price="sender.sender_price"
                                :credit-price="sender.credits_cost"
                                @click="add(sender, category.senders)"
                                >
                                  <template #icon>
                                    <img :src="senderIcon(sender)" :alt="sender.title || t('settings-connections-title')" class="icon"></img>
                                  </template>
                                  <template #badge>
                                    <span v-if="sender.accepting_registration === '0'" class="coming-soon-badge">
                                        {{ t('settings-connections-coming_soon') }}
                                    </span>
                                  </template>
                            </card>
                        </category>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.global-admin #connections-add-page .page-content {
    height: calc(100vh - 90px);
}
</style>
<style scoped lang="scss">
.page-content {
    height: calc(100vh - 20px);
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: 16px;
}
.picker {
    display: flex;
    gap: 24px;
    flex-grow: 1;
    height: 100%;
    overflow-y: hidden;
    .cards-content {
        flex-grow: 1;
        overflow-y: auto;
        gap: 16px;
        display: flex;
        flex-direction: column;
    }
}
</style>
<script>
import SideNav from "../../components/side-nav/side-nav.vue";
import Category from "./components/category.vue";
import Card from "./components/card.vue";
import keviApi from "../../keviApi";
import SenderForm from "./edit/sender-form.vue";
export default {
    components: { SideNav, Category, Card, SenderForm },
    data() {
        return {
            loading: true,
            activePlaceSender: {
                id: null,
                places_id: null,
                senders_id: null,
                alias: null,
                active: null,
                default_sender: null,
                fields: {},
                created_at: null,
                updated_at: null,
                credits_cost: null,
                sender_price: null,
                properties: {},
            },
            activeSender: {
                id: null,
                channel: null,
                logo: null,
                name: null,
                description: null,
                fields: {},
                is_public: '0',
                created_at: null,
                updated_at: null,
                sender_price: 0,
                credits_cost: 0,
                accepting_registration: null,
                by_kevi: '0',
                title: null,
            },
            senders: [],
            categories: {
                whatsapp: {
                    title: this.$_('settings-connections-channels-whatsapp'),
                    description: this.$_('settings-connections-categories-whatsapp_description'),
                    senders: [],
                },
                sms: {
                    title: this.$_('settings-connections-channels-sms'),
                    description: this.$_('settings-connections-categories-sms_description'),
                    senders: [],
                },
                rcs: {
                    title: this.$_('settings-connections-channels-rcs'),
                    description: this.$_('settings-connections-categories-rcs_description'),
                    senders: [],
                },
                email: {
                    title: this.$_('settings-connections-channels-email'),
                    description: this.$_('settings-connections-categories-email_description'),
                    senders: [],
                },
                'whatsapp-cloud': {
                    title: this.$_('settings-connections-channels-whatsapp_cloud'),
                    description: this.$_('settings-connections-categories-whatsapp_cloud_description'),
                    senders: [],
                },
            },
            active: 'all',
            items: [
                { label: this.$_('settings-connections-channels-all'), value: 'all', icon: 'ui-dots-grid' },
                { label: this.$_('settings-connections-channels-whatsapp'), value: 'whatsapp', icon: 'ui-message-chat-square' },
                { label: this.$_('settings-connections-channels-sms'), value: 'sms', icon: 'ui-message-text-square-01' },
                { label: this.$_('settings-connections-channels-rcs'), value: 'rcs', icon: 'ui-message-notification-square' },
                { label: this.$_('settings-connections-channels-email'), value: 'email', icon: 'ui-mail-02' },
                { label: this.$_('settings-connections-channels-whatsapp_cloud'), value: 'whatsapp-cloud', icon: 'ui-message-chat-circle' },
            ],
        };
    },
    computed: {
        navItems() {
            if (this.$module('rcs')) {
                return this.items;
            }
            return this.items.filter((item) => item.value !== 'rcs');
        },
    },
    async mounted() {
        try {
            this.loading = true;
            await this.getSenders();
            this.loading = false;
        } catch (error) {
            this.$store.dispatch("notification/error", this.$_('settings-connections-notifications-load_error', [error?.body?.error || this.$_('settings-connections-notifications-unknown_error')]));
            this.loading = false;
        }
    },
    methods: {
        add(sender, senders) {
            this.activeSender = {...sender};
            const fields = {};
            for(let f in sender.fields) {
                fields[sender.fields[f]] = "";
            }
            this.activePlaceSender = {
                id: null,
                alias: null,
                default_sender: false,
                fields,
                credits_cost: sender.credits_cost,
                sender_price: sender.sender_price,
            };
            this.senders = senders;
            this.$refs.senderForm.open();
        },
        async savedSender(sender) {
            this.activePlaceSender = sender;
        },
        done() {
            this.$router.push({
                path: '/connections',
                query: {
                    tab: this.activeSender.channel,
                },
            });
        },
        async getSenders() {
            // Reset categories before populating to avoid duplicates on remount
            Object.keys(this.categories).forEach(key => {
                this.categories[key].senders = [];
            });
            
            const options = keviApi.getOptions("/senders", "GET");
            const response = await this.$http(options);
            response.body.available_integrations.forEach(sender => {
                if (!this.categories[sender.channel]) {
                    return;
                }
                this.categories[sender.channel].senders.push(sender);
            });
        },
        pick(item) {
            this.active = item.value;
        },
        senderIcon(sender) {
            return '/images/senders/' + sender.name + '.png';
        }
    },
};
</script>
